export default __webpack_public_path__ + "static/media/profile-captain.8955890e.png";